import { Component, Input } from '@angular/core';
import { formatCurrency } from '@angular/common';

import { Globals } from 'app/_models/globals';

import { PurchaseAreaResponse } from '../../_models/purchaseAreaResponses';
import { UserService } from 'app/_services/user.service';

declare const isEmpty: any;
declare const numberWithTwoDecimals: any;
declare const sort_by: any;

@Component({
    selector: 'app-resposta-rodape', templateUrl: 'resposta-rodape.component.html', styleUrls: ['resposta-rodape.component.scss'],
    standalone: false
})
export class BuyerComprarRespostaRodapeComponent {
    @Input() get resposta(): PurchaseAreaResponse {
        return this._resposta;
    }

    set resposta(value: PurchaseAreaResponse) {
        this._resposta = value;
        this.recalcularComponente();
    }

    _resposta: PurchaseAreaResponse;
    respostaRodapeFrete: string = '';
    respostaRodapeFreteValor: number = 0;
    respostaRodapePecasValor: number = 0;
    respostaRodapeTipoPagamento: string = '';
    respostaRodapeTipoPagamentoTooltip: string = '';
    respostaRodapeTotal: number = 0;
    respostaRodapeTotalCia: number = 0;

    constructor(public userService: UserService, private globals: Globals) {}

    calcularTotal() {
        const noneItemSelected = !this.resposta.is_chosen;
        const itens = this.resposta.pecas;
        let total = 0;
        let totalCia = 0;
        let quantity: number;

        for (let i = 0; i <= itens.length - 1; i++) {
            const item = itens[i];

            if ((noneItemSelected || item.is_chosen) && item.displayPart){
                quantity = item.selectedQuantity > 0 ? item.selectedQuantity : item.answer_quantity;
                total += numberWithTwoDecimals(quantity * (item.price * (100 - item.discount_original) / 100));
                totalCia += numberWithTwoDecimals(quantity * ((item.insurance_price ?? 0) * (100 - (item.insurance_discount ?? 0)) / 100));
            }
        }

        this.respostaRodapePecasValor = total;
        this.respostaRodapeTotal = total + this.respostaRodapeFreteValor;
        this.respostaRodapeTotalCia = totalCia;
    }

    calcularFrete() {
        const noneItemSelected = this.getNoneItemSelected();
        let lista_fretes = [];

        // Insere na lista os fretes da região da oficina
        if (!isEmpty(this.resposta) && this.resposta.done_configuration && !isEmpty(this.resposta.shipping))
            lista_fretes = this.resposta.shipping.filter(s => s.region_id === this.resposta.buyer_company_region_id);

        if (isEmpty(lista_fretes) || this.resposta.was_changed) {
            this.resposta.shipping_cost_selecionado = this.resposta.shipping_cost;
            this.resposta.buyer_responsability_selecionado = this.resposta.buyer_responsability;
        } else {
            let total_pecas = this.obterTotalPecasNumerico();
            let frete = lista_fretes[0];
            this.resposta.buyer_responsability_selecionado = frete.buyer_payer;
            this.resposta.shipping_cost_selecionado = frete.buyer_payer || total_pecas >= frete.min_value || frete.shipping_cost === 0 || noneItemSelected ? null : frete.shipping_cost;
        }

        let por_conta_comprador = this.globals.translate('buyer.cotacao.area-respostas.resposta.rodape.frete.conta-comprador');
        let frete_gratuito = this.globals.translate('buyer.mercado-partsfy.carrinho.footer.informacoes-preco.frete-gratis');

        this.respostaRodapeFrete = this.resposta.buyer_responsability_selecionado ?
                                        por_conta_comprador :
                                        ((isEmpty(this.resposta.shipping_cost_selecionado) || this.resposta.shipping_cost_selecionado == 0) ? frete_gratuito : formatCurrency(this.resposta.shipping_cost_selecionado, 'pt-BR', 'R$', 'BRL'));

        this.respostaRodapeFreteValor = this.resposta.buyer_responsability_selecionado || isEmpty(this.resposta.shipping_cost_selecionado) ? 0 : this.resposta.shipping_cost_selecionado;
    }

    getNoneItemSelected() : boolean {
        return !this.resposta.is_chosen && this.resposta.pecas.length > 1 && this.resposta.has_answer;
    }

    montarFormaPagamento() {
        let lista_faturamentos = [];

        // Insere na lista as formas que estão acima do valor selecionado E não são a vista E estão na lista que foi selecionada pelo vendedor
        if (!isEmpty(this.resposta) && !isEmpty(this.resposta.payment_types))
            lista_faturamentos = this.resposta.payment_types.filter(fp => fp.startValue <= this.respostaRodapeTotal && fp.paymentTypeId > 0).map(fp => fp.paymentType);
        else if (this.resposta.tipos_pagamento_formatado.length > 0 && this.resposta.can_be_financed)
            lista_faturamentos.push({ texto_x: this.resposta.tipos_pagamento_formatado[0].name, id: this.resposta.tipos_pagamento_formatado[0].id });

        const indexAVista = lista_faturamentos.findIndex(fp => fp.id == 0);

        if (indexAVista >= 0)
            lista_faturamentos.splice(indexAVista, 1);

        lista_faturamentos.push({ texto_x: this.globals.translate('buyer.cotacao.area-respostas.resposta.rodape.pagamento-a-vista'), id: 0 });
        lista_faturamentos.sort(sort_by([{ name: 'id', reverse: true }])); // Ordena a lista pela maior opção

        const is_pagamento_avista = lista_faturamentos[0].id == 0;

        this.respostaRodapeTipoPagamentoTooltip = '';
        this.respostaRodapeTipoPagamento = is_pagamento_avista ? lista_faturamentos[0].texto_x : this.globals.translate('buyer.cotacao.area-comprar.selecionados.rodape.faturamento.faturado-ate') + lista_faturamentos[0].texto_x;

        if (!is_pagamento_avista)
            return;

        if (!this.resposta.can_be_financed) {
            this.respostaRodapeTipoPagamentoTooltip = `${this.globals.translate('buyer.cotacao.area-respostas.resposta.rodape.faturamento-nao-liberado')} - ${this.globals.translate('buyer.cotacao.area-respostas.resposta.rodape.verificar-disponibilidade')}`;
            return;
        }

        this.respostaRodapeTipoPagamentoTooltip = this.globals.translate('buyer.cotacao.area-respostas.resposta.rodape.verificar-disponibilidade');
    }

    obterTotalPecasNumerico() {
        var itens = this.resposta.pecas;
        var total = 0;

        for (var i = 0; i <= itens.length - 1; i++) {
            var item = itens[i];

            if (item.is_chosen && item.displayPart)
                total += item.preco_final;
        }

        return total;
    }

    recalcularComponente() {
        this.calcularFrete(); // Primeiro calcula o frete
        this.calcularTotal(); // Para depois calcular o total
        this.montarFormaPagamento(); // E por fim, definir a forma de pagamento
    }
}
